export default class ToolbarSearchInputController {

}
